import type { RouteObject } from 'react-router-dom';

const onboardingRoutes: RouteObject[] = [
    {
        path: 'onboarding',
        children: [
            {
                path: '',
                async lazy() {
                    const OnboardingInfo = await import(
                        '../features/onboarding-info'
                    );

                    return {
                        Component: OnboardingInfo.default,
                    };
                },
            },
            {
                path: 'pair',
                async lazy() {
                    const PairRegister = await import(
                        '../features/pair-register/pair-register'
                    );

                    return {
                        Component: PairRegister.default,
                    };
                },
            },
            {
                path: 'select-branch',
                async lazy() {
                    const SelectBranch = await import(
                        '../features/select-branch'
                    );

                    return {
                        Component: SelectBranch.default,
                    };
                },
            },
            {
                path: 'switch-branch',
                async lazy() {
                    const SwitchBranch = await import(
                        '../features/switch-branch'
                    );

                    return { Component: SwitchBranch.default };
                },
            },
            {
                path: 'login',
                async lazy() {
                    const Login = await import('../features/auth/login/login');

                    return {
                        Component: Login.default,
                    };
                },
            },
            {
                path: 'pin-upgrade-signed-out',
                async lazy() {
                    const PinUpgradeSignedOut = await import(
                        '../features/auth/pin-upgrade-signed-out/pin-upgrade-signed-out'
                    );

                    return { Component: PinUpgradeSignedOut.default };
                },
            },
        ],
    },
];

// eslint-disable-next-line import/no-default-export
export default onboardingRoutes;
